import { useState, useRef, useEffect, ReactNode, LegacyRef } from "react";
import { connect } from "react-redux";

import { PuffLoader } from "react-spinners";

interface LoadingWrapperProps {
  children?: ReactNode;
  className?: any;
  loading?: any;
  loadingKey?: any;
  loadingState?: any;
  height?: number;
  smallBlock?: boolean;
  width?: number;
}

const LoadingWrapper = ({
  children,
  className,
  loading,
  loadingKey,
  loadingState,
  height,
  smallBlock,
  width,
}: LoadingWrapperProps) => {
  const [rememberHeight, setRememberHeight] = useState(height ?? 150);
  const [rememberWidth, setRememberWidth] = useState(width ?? 150);
  const refContainer = useRef<HTMLElement>(null);
  useEffect(() => {
    if ((loadingKey ? !loading[loadingKey] : !loadingState) && refContainer.current) {
      setRememberHeight(Math.max(refContainer.current?.clientHeight ?? 20, 20));
      setRememberWidth(Math.max(refContainer.current?.clientWidth ?? 20, 20));
    }
  }, [refContainer, loading, loadingKey, setRememberHeight, setRememberWidth]);
  return (
    <>
      {(loadingKey ? loading[loadingKey] : loadingState) && (
        <div
          style={{
            width: rememberWidth + "px",
            height: (rememberHeight < 200 ? rememberHeight : 200) + "px",
            display: smallBlock ? "inline-flex" : "flex",
            textAlign: "center",
            verticalAlign: "middle",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <PuffLoader
            size={
              ((rememberWidth < rememberHeight ? rememberWidth : rememberHeight) < 200
                ? rememberWidth < rememberHeight
                  ? rememberWidth
                  : rememberHeight
                : 200) - 4
            }
            color="#32325d"
            loading
            css="margin: 0"
          />
        </div>
      )}
      {(loadingKey ? !loading[loadingKey] : !loadingState) && (
        <>
          <div
            style={{ display: smallBlock ? "inline-block" : "block" }}
            className={className}
            ref={refContainer as LegacyRef<HTMLDivElement>}
          >
            {children}
          </div>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: { basic: { loading: any } }) => {
  return {
    loading: state.basic.loading,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LoadingWrapper);
